import React from "react";
import embroidery from "../assets/embroidery.svg";

function Home() {
  return (
    <>
      <section class="banner-area" style={{ zIndex: "unset" }}>
        <svg
          class="banner-svg"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 1440 320"
        >
          <path
            fill-opacity="1"
            d="M0,192L26.7,197.3C53.3,203,107,213,160,234.7C213.3,256,267,288,320,282.7C373.3,277,427,235,480,208C533.3,181,587,171,640,186.7C693.3,203,747,245,800,240C853.3,235,907,181,960,144C1013.3,107,1067,85,1120,96C1173.3,107,1227,149,1280,154.7C1333.3,160,1387,128,1413,112L1440,96L1440,0L1413.3,0C1386.7,0,1333,0,1280,0C1226.7,0,1173,0,1120,0C1066.7,0,1013,0,960,0C906.7,0,853,0,800,0C746.7,0,693,0,640,0C586.7,0,533,0,480,0C426.7,0,373,0,320,0C266.7,0,213,0,160,0C106.7,0,53,0,27,0L0,0Z"
          ></path>
        </svg>
        <div class="banner-fluid" style={{ zIndex: "unset" }}>
          <div class="banner-item-wrap">
            <div id="perticles-js"></div>
            <div class="banner-item-table">
              <div class="banner-item-tablecell">
                <div class="container">
                  <div class="row">
                    <div class="col-lg-12">
                      <div class="banner-content text-center">
                        <div class="section-heading">
                          <p class="section__meta">#welcome to Dotemb</p>
                          <h2 class="section__title">
                            Your Partner in Precision <br /> Embroidery
                            Digitizing
                          </h2>
                        </div>
                        <div class="section-description">
                          <p class="section__desc">
                            With a passion for precision and an unwavering
                            commitment to quality, <br />
                            we bring your designs to life through the artistry
                            of embroidery.
                          </p>
                        </div>
                        <div class="btn-box">
                          <a href="/contact" class="theme-btn">
                            Get a Quote<span class="la la-caret-right"></span>
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section class="about-area section-padding">
        <div class="circle-shape circle-shape1"></div>
        <div class="circle-shape circle-shape2"></div>
        <div class="circle-shape circle-shape3"></div>
        <div class="circle-shape circle-shape4"></div>
        <div class="container">
          <div class="row">
            <div class="col-lg-6">
              <div class="about-item">
                <div class="about-heading section-heading">
                  <h5 class="section__meta">#about company</h5>
                  <h2 class="section__title">Welcome to Dotemb</h2>
                  <div class="section-divider"></div>
                </div>
                <div class="section-description">
                  <p class="section__desc">
                    At Dotemb, we take pride in being a mid-sized embroidery
                    digitizing company dedicated to transforming creative
                    visions into intricately stitched realities. With a passion
                    for precision and an unwavering commitment to quality, we
                    bring your designs to life through the artistry of
                    embroidery.
                  </p>
                </div>
                <ul class="list-items">
                  <li>
                    <span class="la la-certificate"></span>
                    <h3>Certified Company</h3>
                    <p>
                      Dotemb is proud to be a certified company, dedicated to
                      upholding the highest standards in embroidery digitizing.
                      Our certifications reflect our commitment to quality,
                      precision, and customer satisfaction.
                    </p>
                  </li>
                  <li>
                    <span class="la la-users"></span>
                    <h3>Experience Employee</h3>
                    <p>
                      At Dotemb, we take pride in our team of experienced and
                      dedicated professionals. Our success is built on the
                      expertise, creativity, and passion of each member of our
                      team.
                    </p>
                  </li>
                </ul>
              </div>
            </div>
            <div class="col-lg-6">
              <div class="image-box">
                <img
                  src="assets/images/emb5.png"
                  alt="about-img"
                  class="img__item"
                />{" "}
                <img
                  src="assets/images/IMG_69041.png"
                  alt="about-img"
                  class="img__item"
                />
                <img
                  src="assets/images/IMG_6879.png"
                  alt="about-img"
                  class="img__item"
                />
                <img
                  src="assets/images/emb1.png"
                  alt="about-img"
                  class="img__item"
                />
              </div>
            </div>
          </div>
        </div>
      </section>
      <section class="feature-area section--padding">
        <div class="circle-shape circle-shape1"></div>
        <div class="circle-shape circle-shape2"></div>
        <div class="circle-shape circle-shape3"></div>
        <div class="circle-shape circle-shape4"></div>
        <div class="container">
          <div class="row feature-content-wrap">
            <div class="col-lg-3 col-sm-6">
              <div class="feature-item feature-box-color">
                <div class="hover-overlay"></div>
                <div class="feature__icon">
                  <div class="div-strokes">
                    <span class="stroke__bar stroke__one"></span>
                    <span class="stroke__bar stroke__two"></span>
                    <span class="stroke__bar stroke__three"></span>
                  </div>
                  <i class="la la-cog"></i>
                </div>
                <h3 class="feature__title">24/7 Services & Customer Support</h3>
                <p class="feature__text">
                  At Dotemb, we understand that your embroidery. That's why we
                  are proud to offer 24/7 services and customer support.
                </p>
              </div>
            </div>
            <div class="col-lg-3 col-sm-6">
              <div class="feature-item feature-box-color-2">
                <div class="hover-overlay"></div>
                <div class="feature__icon">
                  <div class="div-strokes">
                    <span class="stroke__bar stroke__one"></span>
                    <span class="stroke__bar stroke__two"></span>
                    <span class="stroke__bar stroke__three"></span>
                  </div>
                  <i class="la la-certificate"></i>
                </div>
                <h3 class="feature__title">Easy, Fast & Secure Checkout</h3>
                <p class="feature__text">
                  At Dotemb, we prioritize your convenience. Our easy, fast, and
                  secure checkout process is designed to make your embroidery
                  digitizing orders a breeze.
                </p>
              </div>
            </div>
            <div class="col-lg-3 col-sm-6">
              <div class="feature-item feature-box-color-3">
                <div class="hover-overlay"></div>
                <div class="feature__icon">
                  <div class="div-strokes">
                    <span class="stroke__bar stroke__one"></span>
                    <span class="stroke__bar stroke__two"></span>
                    <span class="stroke__bar stroke__three"></span>
                  </div>
                  <i class="la la-microphone"></i>
                </div>
                <h3 class="feature__title">Fastest Turnaround</h3>
                <p class="feature__text">
                  At Dotemb, we understand the importance of time in the
                  creative process. That's why we take pride in offering the
                  fastest turnaround for your embroidery digitizing needs.
                </p>
              </div>
            </div>{" "}
            <div class="col-lg-3 col-sm-6">
              <div class="feature-item feature-box-color-2">
                <div class="hover-overlay"></div>
                <div class="feature__icon">
                  <div class="div-strokes">
                    <span class="stroke__bar stroke__one"></span>
                    <span class="stroke__bar stroke__two"></span>
                    <span class="stroke__bar stroke__three"></span>
                  </div>
                  <i class="la la-desktop"></i>
                </div>
                <h3 class="feature__title">Software are used</h3>
                <p class="feature__text">
                  <b> 1.Wilcom</b> : The world's favorite embroidery digitizing
                  software. <br />
                  <b>2. Tajima PLUS </b>: Tajima PLUS is a software that
                  converts text to embroidery data. It can also create
                  embroidery data by combining text and registered designs.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section class="info-box-area section-padding-bottom-2">
        <div class="container">
          <div class="row">
            <div class="col-lg-8 mx-auto">
              <div class="section-heading text-center">
                <h5 class="section__meta">#services</h5>
                <h2 class="section__title">What We do?</h2>
                <div class="section-divider mx-auto"></div>
              </div>
              <div class="section-description m-0 text-center">
                <p class="section__desc">
                  At Dotemb, we take pride in being a mid-sized embroidery
                  digitizing company dedicated to transforming creative visions
                  into intricately stitched realities
                </p>
              </div>
            </div>
          </div>
          <div class="row info-box-wrap">
            <div class="col-lg-4 col-sm-6">
              <div class="info-box-item info-box-item-4">
                <div class="info-header">
                  <svg
                    class="infobg__svg"
                    width="180"
                    height="180"
                    viewBox="0 0 600 600"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <g transform="translate(300,300)">
                      <path d="M125.6,-88.7C153,-25,158.8,35,134.2,52.8C109.7,70.7,54.8,46.3,9.7,40.8C-35.5,35.2,-71,48.3,-103.2,26.1C-135.4,3.8,-164.3,-53.8,-146.5,-111.9C-128.7,-170,-64.4,-228.5,-7.6,-224.1C49.1,-219.7,98.1,-152.3,125.6,-88.7Z" />
                    </g>
                  </svg>
                  <svg
                    class="info__svg"
                    viewBox="0 0 569 569.54905"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path d="m1.527344 52.246094 37.984375 66.46875c1.28125 2.246094 3.425781 3.871094 5.933593 4.5l35.4375 8.859375 121.542969 121.542969 13.429688-13.425782-123.445313-123.441406c-1.214844-1.21875-2.738281-2.082031-4.40625-2.5l-34.050781-8.542969-32.339844-56.625 27.726563-27.726562 56.648437 32.371093 8.546875 34.050782c.414063 1.671875 1.28125 3.199218 2.496094 4.414062l123.445312 123.445313 13.425782-13.429688-121.542969-121.542969-8.859375-35.417968c-.628906-2.511719-2.253906-4.660156-4.5-5.945313l-66.472656-37.980469c-3.707032-2.109374-8.371094-1.484374-11.394532 1.527344l-37.980468 37.984375c-3.0546878 3.003907-3.71875 7.675781-1.625 11.414063zm0 0" />
                    <path d="m396.3125 187.144531-208.902344 208.90625-13.429687-13.429687 208.90625-208.902344zm0 0" />
                    <path d="m150.847656 403.441406c-1.71875-2.859375-4.804687-4.605468-8.140625-4.605468h-56.972656c-3.332031 0-6.421875 1.746093-8.136719 4.605468l-28.488281 47.476563c-1.808594 3.007812-1.808594 6.769531 0 9.78125l28.488281 47.476562c1.714844 2.855469 4.804688 4.605469 8.136719 4.605469h56.972656c3.335938 0 6.421875-1.75 8.140625-4.605469l28.484375-47.476562c1.808594-3.011719 1.808594-6.773438 0-9.78125zm-13.511718 90.347656h-46.226563l-22.789063-37.980468 22.789063-37.984375h46.226563l22.789062 37.984375zm0 0" />
                    <path d="m456.0625 227.914062c62.714844.210938 113.730469-50.460937 113.941406-113.175781.03125-9.546875-1.140625-19.054687-3.488281-28.308593-1.265625-5.089844-6.417969-8.1875-11.507813-6.921876-1.671874.417969-3.195312 1.28125-4.414062 2.496094l-59.109375 59.070313-46.898437-15.628907-15.640626-46.886718 59.109376-59.121094c3.707031-3.710938 3.703124-9.722656-.007813-13.429688-1.222656-1.222656-2.761719-2.089843-4.445313-2.503906-60.820312-15.402344-122.605468 21.414063-138.007812 82.230469-2.339844 9.226563-3.507812 18.710937-3.476562 28.230469.023437 7.476562.792968 14.929687 2.308593 22.25l-207.957031 207.953125c-7.320312-1.511719-14.773438-2.28125-22.246094-2.308594-62.933594 0-113.949218 51.015625-113.949218 113.949219 0 62.929687 51.015624 113.945312 113.949218 113.945312 62.929688 0 113.945313-51.015625 113.945313-113.945312-.023438-7.476563-.796875-14.929688-2.308594-22.25l49.785156-49.785156 21.773438 21.773437c3.710937 3.707031 9.71875 3.707031 13.429687 0l4.746094-4.75c4.164062-4.136719 10.894531-4.136719 15.058594 0 4.160156 4.148437 4.167968 10.882813.019531 15.042969-.003906.003906-.011719.011718-.019531.019531l-4.746094 4.746094c-3.707031 3.707031-3.707031 9.71875 0 13.425781l113.273438 113.273438c29.792968 30.066406 78.316406 30.285156 108.382812.492187 30.0625-29.792969 30.28125-78.320313.488281-108.382813-.160156-.164062-.324219-.328124-.488281-.492187l-113.273438-113.269531c-3.707031-3.707032-9.71875-3.707032-13.425781 0l-4.746093 4.746094c-4.167969 4.140624-10.894532 4.140624-15.0625 0-4.15625-4.148438-4.167969-10.882813-.019532-15.039063.007813-.007813.015625-.011719.019532-.019531l4.75-4.75c3.707031-3.707032 3.707031-9.71875 0-13.425782l-21.773438-21.773437 49.785156-49.785156c7.320313 1.511719 14.773438 2.285156 22.246094 2.308593zm37.308594 322.851563c-6.898438-.011719-13.738282-1.257813-20.195313-3.683594l74.160157-74.164062c11.191406 29.769531-3.867188 62.972656-33.636719 74.164062-6.496094 2.441407-13.382813 3.691407-20.328125 3.683594zm-107.574219-246.792969c-10.515625 12.542969-8.867187 31.238282 3.675781 41.75 11.023438 9.238282 27.089844 9.230469 38.101563-.027344l106.5625 106.65625c1.15625 1.160157 2.238281 2.382813 3.285156 3.625l-81.1875 81.1875c-1.246094-1.042968-2.46875-2.125-3.628906-3.285156l-106.644531-106.652344c10.515624-12.542968 8.867187-31.238281-3.675782-41.75-11.023437-9.242187-27.09375-9.230468-38.105468.023438l-15.191407-15.191406 81.613281-81.492188zm38.34375-95.503906-215.410156 215.367188c-2.363281 2.359374-3.3125 5.785156-2.507813 9.023437 13.027344 51.160156-17.886718 103.195313-69.050781 116.21875-51.160156 13.027344-103.195313-17.886719-116.222656-69.050781-13.023438-51.160156 17.890625-103.195313 69.054687-116.222656 15.476563-3.9375 31.691406-3.9375 47.167969 0 3.238281.792968 6.65625-.15625 9.023437-2.503907l215.359376-215.371093c2.359374-2.359376 3.308593-5.785157 2.496093-9.019532-12.9375-50.5625 17.5625-102.039062 68.125-114.980468 9.554688-2.441407 19.4375-3.378907 29.28125-2.765626l-50.089843 50.109376c-2.542969 2.539062-3.433594 6.300781-2.296876 9.710937l18.988282 56.976563c.949218 2.832031 3.175781 5.058593 6.011718 6l56.976563 18.992187c3.40625 1.136719 7.167969.25 9.710937-2.289063l50.089844-50.089843c.113282 1.8125.171875 3.605469.171875 5.390625.265625 52.175781-41.8125 94.6875-93.988281 94.957031-8.066406.039063-16.105469-.953125-23.917969-2.953125-3.238281-.808594-6.664062.136719-9.023437 2.496094h.050781zm0 0" />
                    <path d="m491.273438 477.578125-13.429688 13.429687-94.953125-94.953124 13.425781-13.429688zm0 0" />
                  </svg>
                </div>
                <div class="info-body">
                  <h3 class="info__title">
                    <a href="/embroidery">Embroidery Digitizing</a>{" "}
                  </h3>
                  <p class="info__text">
                    Transform your unique designs into flawless embroidery with
                    our custom digitizing service. Whether it's intricate
                    patterns or detailed artwork, our skilled team ensures that
                    every nuance is translated into a digitized masterpiece.
                  </p>
                </div>
              </div>
            </div>
            <div class="col-lg-4 col-sm-6">
              <div class="info-box-item info-box-item-4">
                <div class="info-header">
                  <svg
                    class="infobg__svg"
                    width="180"
                    height="180"
                    viewBox="0 0 600 600"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <g transform="translate(300,300)">
                      <path d="M125.6,-88.7C153,-25,158.8,35,134.2,52.8C109.7,70.7,54.8,46.3,9.7,40.8C-35.5,35.2,-71,48.3,-103.2,26.1C-135.4,3.8,-164.3,-53.8,-146.5,-111.9C-128.7,-170,-64.4,-228.5,-7.6,-224.1C49.1,-219.7,98.1,-152.3,125.6,-88.7Z" />
                    </g>
                  </svg>
                  <svg
                    class="info__svg"
                    version="1.1"
                    id="Capa_2"
                    xmlns="http://www.w3.org/2000/svg"
                    x="0px"
                    y="0px"
                    viewBox="0 0 60 60"
                  >
                    <path
                      d="M58.681,46h0.042l-0.238-1.177L52.347,8H17.5V6c0-2.206,1.794-4,4-4s4,1.794,4,4c0,0.553,0.448,1,1,1s1-0.447,1-1
                                c0-3.309-2.691-6-6-6s-6,2.691-6,6v2H7.653L1.516,44.823L1.278,46h0.042H25.5v9h-3v5h15v-5h-3v-9H58.681z M9.347,10H15.5v7
                                c0,0.553,0.448,1,1,1s1-0.447,1-1v-7h33.153l4.5,27H4.847L9.347,10z M3.722,44l1.01-5h50.536l1.01,5H34.5h-9H3.722z M35.5,57v1h-11
                                v-1h1h9H35.5z M32.5,55h-5v-9h5V55z"
                    />
                  </svg>
                </div>
                <div class="info-body">
                  <h3 class="info__title">
                    <a href="/vector">Vector Art Conversion</a>{" "}
                  </h3>
                  <p class="info__text">
                    Convert raster images into scalable vector formats, opening
                    up new possibilities for embroidery. Our vector art
                    conversion services enable you to achieve high-quality
                    results, even with the most intricate designs.
                  </p>
                </div>
              </div>
            </div>
            <div class="col-lg-4 col-sm-6">
              <div class="info-box-item info-box-item-4">
                <div class="info-header">
                  <svg
                    class="infobg__svg"
                    width="180"
                    height="180"
                    viewBox="0 0 600 600"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <g transform="translate(300,300)">
                      <path d="M125.6,-88.7C153,-25,158.8,35,134.2,52.8C109.7,70.7,54.8,46.3,9.7,40.8C-35.5,35.2,-71,48.3,-103.2,26.1C-135.4,3.8,-164.3,-53.8,-146.5,-111.9C-128.7,-170,-64.4,-228.5,-7.6,-224.1C49.1,-219.7,98.1,-152.3,125.6,-88.7Z" />
                    </g>
                  </svg>
                  <svg
                    class="info__svg"
                    viewBox="0 0 64 64"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path d="m61.234 18.322a3 3 0 0 0 -4.243 0l-6.364 6.365a1 1 0 1 1 -1.414-1.415l.694-.694.013-.013 1.414-1.414a3 3 0 1 0 -4.242-4.243l-2.828 2.828a1 1 0 1 1 -1.415-1.414l2.829-2.828a3 3 0 1 0 -4.243-4.243l-2.829 2.829a1.022 1.022 0 0 1 -1.414 0 1 1 0 0 1 0-1.413l5.071-5.067a3 3 0 0 0 0-4.243 3.071 3.071 0 0 0 -4.243 0l-8.745 8.743a3.073 3.073 0 0 0 -3.4.569l-5.658 5.656a3 3 0 0 0 0 4.243l19.8 19.8a3 3 0 0 0 4.242 0l.707-.707 1.415 1.414-4.243 4.243-12.723-12.732a3.071 3.071 0 0 0 -4.243 0l-7.909 7.908a2.993 2.993 0 0 0 -3.405.577l-10.607 10.607a3 3 0 0 0 0 4.242l2.829 2.829a3 3 0 0 0 4.242 0l10.607-10.607a3 3 0 0 0 .577-3.405l5.787-5.787 12.728 12.728a3 3 0 0 0 4.242 0l8.486-8.486a3 3 0 0 0 0-4.242l-3.536-3.536.708-.707a3 3 0 0 0 .579-3.407l10.734-10.735a3 3 0 0 0 0-4.243zm-18.385 22.628a1.022 1.022 0 0 1 -1.413 0l-19.8-19.8a1 1 0 0 1 0-1.415l5.657-5.656a1 1 0 0 1 1.414 0l19.8 19.8a1 1 0 0 1 0 1.415zm-23.334 7.778-10.607 10.606a1 1 0 0 1 -1.414 0l-2.828-2.828a1 1 0 0 1 0-1.414l10.606-10.607a1 1 0 0 1 1.415 0l2.828 2.828a1 1 0 0 1 0 1.415zm31.819-6.364a1 1 0 0 1 0 1.414l-8.485 8.486a1.025 1.025 0 0 1 -1.414 0l-12.728-12.728a2 2 0 0 0 -2.828 0l-5.657 5.656-1.414-1.414 7.778-7.778a1.023 1.023 0 0 1 1.414 0l12.729 12.729a2 2 0 0 0 2.827 0l4.244-4.244a2 2 0 0 0 0-2.828l-1.414-1.414 1.414-1.415zm8.486-21.213-10.607 10.606-18.385-18.385 8.608-8.606a1.021 1.021 0 0 1 1.413 0 1 1 0 0 1 0 1.413l-5.071 5.071a3 3 0 0 0 0 4.243 3.073 3.073 0 0 0 4.243 0l2.828-2.828a1 1 0 0 1 1.415 1.414l-2.829 2.828a3 3 0 0 0 4.243 4.243l2.828-2.829a1.023 1.023 0 0 1 1.414 0 1 1 0 0 1 0 1.415l-2.12 2.122a3 3 0 0 0 4.242 4.242l6.363-6.364a1 1 0 1 1 1.415 1.414z" />
                    <path d="m49.213 10.714a3 3 0 1 1 2.121-.877 2.988 2.988 0 0 1 -2.121.877zm0-4a1 1 0 1 0 .707 1.707 1 1 0 0 0 -.707-1.706z" />
                    <path d="m54.87 16.373a3 3 0 0 1 -2.121-5.122 3.073 3.073 0 0 1 4.243 0 3 3 0 0 1 0 4.243 2.978 2.978 0 0 1 -2.122.879zm0-4a1 1 0 0 0 -.707 1.706 1.022 1.022 0 0 0 1.414 0 1 1 0 0 0 -.707-1.706z" />
                  </svg>
                </div>
                <div class="info-body">
                  <h3 class="info__title">
                    <a href="/puff">3D / PUFF Digitizing</a>{" "}
                  </h3>
                  <p class="info__text">
                    Dotemb takes embroidery to the next level with our
                    specialized 3D/Puff digitizing services. Experience the
                    transformation of your designs into textured,
                    three-dimensional masterpieces that stand out with depth and
                    visual impact.
                  </p>
                </div>
              </div>
            </div>
            <div class="col-lg-4 col-sm-6">
              <div class="info-box-item info-box-item-4">
                <div class="info-header">
                  <svg
                    class="infobg__svg"
                    width="180"
                    height="180"
                    viewBox="0 0 600 600"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <g transform="translate(300,300)">
                      <path d="M125.6,-88.7C153,-25,158.8,35,134.2,52.8C109.7,70.7,54.8,46.3,9.7,40.8C-35.5,35.2,-71,48.3,-103.2,26.1C-135.4,3.8,-164.3,-53.8,-146.5,-111.9C-128.7,-170,-64.4,-228.5,-7.6,-224.1C49.1,-219.7,98.1,-152.3,125.6,-88.7Z" />
                    </g>
                  </svg>
                  <svg
                    class="info__svg"
                    version="1.1"
                    id="Capa_2"
                    xmlns="http://www.w3.org/2000/svg"
                    x="0px"
                    y="0px"
                    viewBox="0 0 60 60"
                  >
                    <path
                      d="M58.681,46h0.042l-0.238-1.177L52.347,8H17.5V6c0-2.206,1.794-4,4-4s4,1.794,4,4c0,0.553,0.448,1,1,1s1-0.447,1-1
                                c0-3.309-2.691-6-6-6s-6,2.691-6,6v2H7.653L1.516,44.823L1.278,46h0.042H25.5v9h-3v5h15v-5h-3v-9H58.681z M9.347,10H15.5v7
                                c0,0.553,0.448,1,1,1s1-0.447,1-1v-7h33.153l4.5,27H4.847L9.347,10z M3.722,44l1.01-5h50.536l1.01,5H34.5h-9H3.722z M35.5,57v1h-11
                                v-1h1h9H35.5z M32.5,55h-5v-9h5V55z"
                    />
                  </svg>
                </div>
                <div class="info-body">
                  <h3 class="info__title">
                    <a href="/applique">Applique Digitizing</a>{" "}
                  </h3>
                  <p class="info__text">
                    Dotemb is your go-to destination for high-quality Appliqué
                    digitizing services, where traditional craftsmanship meets
                    cutting-edge digitization techniques. Elevate your
                    embroidery projects with the rich textures and vibrant
                    colors of appliqué.
                  </p>
                </div>
              </div>
            </div>
            <div class="col-lg-4 col-sm-6">
              <div class="info-box-item info-box-item-4">
                <div class="info-header">
                  <svg
                    class="infobg__svg"
                    width="180"
                    height="180"
                    viewBox="0 0 600 600"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <g transform="translate(300,300)">
                      <path d="M125.6,-88.7C153,-25,158.8,35,134.2,52.8C109.7,70.7,54.8,46.3,9.7,40.8C-35.5,35.2,-71,48.3,-103.2,26.1C-135.4,3.8,-164.3,-53.8,-146.5,-111.9C-128.7,-170,-64.4,-228.5,-7.6,-224.1C49.1,-219.7,98.1,-152.3,125.6,-88.7Z" />
                    </g>
                  </svg>
                  <svg
                    class="info__svg"
                    version="1.1"
                    id="Capa_3"
                    xmlns="http://www.w3.org/2000/svg"
                    x="0px"
                    y="0px"
                    viewBox="0 0 512 512"
                  >
                    <g>
                      <g>
                        <path
                          d="M506.552,317.933c-9.739-14.312-29.351-18.1-43.707-8.452l-65.34,43.728l-0.19-136.11l22.7,21.265
                                            c4.827,4.521,11.121,7.009,17.729,7.009c0.012,0,0.026,0,0.039,0c7.134-0.01,14.022-3,18.898-8.205
                                            c4.737-5.057,7.222-11.655,6.996-18.581c-0.226-6.926-3.136-13.349-8.193-18.086l-43.035-40.314
                                            c-2.946-2.76-7.571-2.609-10.33,0.337c-2.759,2.946-2.608,7.57,0.337,10.33l43.035,40.314c2.208,2.068,3.478,4.872,3.577,7.895
                                            c0.098,3.023-0.986,5.904-3.055,8.111c-2.16,2.306-5.09,3.578-8.252,3.582c-0.006,0-0.011,0-0.017,0
                                            c-2.883,0-5.63-1.086-7.737-3.06c-0.001-0.001-0.001-0.001-0.001-0.001L259.124,67.616c-2.816-2.637-7.198-2.633-10.007,0.014
                                            L78.679,228.188c-2.201,2.074-5.079,3.16-8.103,3.076c-3.024-0.09-5.831-1.353-7.905-3.556c-2.074-2.201-3.167-5.079-3.076-8.102
                                            c0.09-3.024,1.353-5.831,3.554-7.905L246.326,39.143c4.342-4.091,11.154-4.101,15.507-0.021L369,139.514
                                            c2.945,2.759,7.57,2.609,10.33-0.337c2.759-2.946,2.608-7.57-0.337-10.33L271.827,28.455c-9.973-9.344-25.576-9.323-35.523,0.049
                                            l-58.639,55.24l-0.016-9.853c-0.004-3.106-1.218-6.024-3.417-8.216c-2.195-2.189-5.109-3.394-8.209-3.394
                                            c-0.006,0-0.011,0-0.017,0l-41.947,0.059c-3.106,0.004-6.023,1.218-8.216,3.417c-2.192,2.199-3.398,5.12-3.393,8.227l0.116,71.087
                                            l-59.439,55.993c-5.044,4.751-7.935,11.182-8.142,18.108c-0.207,6.926,2.296,13.518,7.047,18.56
                                            c4.75,5.044,11.181,7.936,18.108,8.143c0.265,0.008,0.53,0.012,0.795,0.012c6.635,0,12.918-2.49,17.767-7.06l22.649-21.336
                                            l0.09,64.291c-7.328-1.067-14.742-1.627-22.19-1.627H76.746v-4.382c0-14.711-11.969-26.68-26.68-26.68H26.68
                                            C11.969,249.092,0,261.06,0,275.772V390.29c0,4.036,3.272,7.308,7.308,7.308s7.308-3.272,7.308-7.308V275.772
                                            c0-6.652,5.412-12.064,12.064-12.064h23.385c6.652,0,12.064,5.412,12.064,12.064v11.69v149.796v11.575
                                            c0,6.652-5.412,12.064-12.064,12.064H26.68c-6.652,0-12.064-5.412-12.064-12.064v-12.788c0-4.036-3.272-7.308-7.308-7.308
                                            S0,432.009,0,436.045v12.788c0,14.711,11.969,26.68,26.68,26.68h23.385c14.711,0,26.68-11.968,26.68-26.68v-0.993l107.024,40.528
                                            c0.198,0.075,0.399,0.141,0.603,0.198c4.653,1.314,9.304,1.973,13.896,1.973c2.484,0,4.951-0.193,7.393-0.579l157.281-22.672
                                            c0.037-0.005,0.073-0.011,0.11-0.017c13.372-2.135,25.987-7.788,36.48-16.346c0.091-0.074,0.181-0.151,0.268-0.23l101.611-91.388
                                            C513.244,348.802,515.453,331.015,506.552,317.933z M163.037,76.902l0.034,20.59l-35.912,33.83l-0.089-54.371L163.037,76.902z
                                             M254.141,82.976l128.538,120.412l0.223,159.593l-20.691,13.848L340.3,375.6l-0.579-5.82
                                            c-2.039-20.498-17.171-36.987-37.18-40.922l-0.132-94.945c-0.01-7.286-5.942-13.207-13.227-13.207c-0.006,0-0.011,0-0.018,0
                                            l-69.654,0.098c-3.533,0.005-6.853,1.385-9.347,3.887c-2.495,2.501-3.866,5.825-3.861,9.357l0.116,82.781
                                            c-13.797-3.154-26.971-8.363-39.288-15.568c-1.537-0.899-3.089-1.767-4.654-2.611c-0.61-0.329-1.23-0.638-1.845-0.959
                                            c-0.952-0.497-1.902-0.997-2.864-1.474c-0.766-0.38-1.541-0.74-2.313-1.107c-0.819-0.389-1.637-0.782-2.462-1.157
                                            c-0.84-0.381-1.687-0.744-2.533-1.11c-0.773-0.334-1.546-0.67-2.324-0.991c-0.87-0.359-1.745-0.704-2.621-1.047
                                            c-0.777-0.304-1.555-0.606-2.336-0.898c-0.867-0.324-1.738-0.637-2.611-0.944c-0.819-0.289-1.639-0.571-2.463-0.846
                                            c-0.836-0.279-1.674-0.552-2.516-0.817c-0.897-0.283-1.798-0.553-2.7-0.82c-0.775-0.228-1.549-0.456-2.328-0.672
                                            c-1.017-0.283-2.039-0.548-3.062-0.81c-0.479-0.123-0.955-0.262-1.437-0.381l-0.113-80.878L254.141,82.976z M287.923,327.029
                                            l-61.125-7.037l-5.759-0.663l-0.118-83.911l66.874-0.094L287.923,327.029z M491.673,348.41l-101.511,91.298
                                            c-8.459,6.859-18.606,11.396-29.361,13.122l-157.213,22.662c-0.033,0.005-0.065,0.01-0.098,0.015l-0.109,0.017
                                            c-4.763,0.754-9.723,0.436-14.744-0.942L76.746,432.21V294.77h12.505c10.645,0,21.218,1.229,31.514,3.616
                                            c0.383,0.089,0.765,0.18,1.147,0.272c1.265,0.305,2.527,0.619,3.783,0.959c0.11,0.03,0.219,0.062,0.329,0.092
                                            c1.259,0.344,2.513,0.707,3.763,1.086c0.224,0.068,0.449,0.135,0.672,0.204c1.33,0.411,2.654,0.84,3.971,1.29
                                            c0.136,0.047,0.271,0.095,0.407,0.142c2.743,0.947,5.459,1.98,8.141,3.098c0.146,0.061,0.292,0.122,0.438,0.184
                                            c1.337,0.562,2.666,1.143,3.986,1.747c0.035,0.016,0.071,0.033,0.106,0.05c1.276,0.586,2.543,1.194,3.802,1.819
                                            c0.148,0.073,0.297,0.145,0.445,0.219c1.23,0.615,2.45,1.252,3.663,1.904c0.229,0.123,0.457,0.249,0.686,0.373
                                            c1.224,0.667,2.441,1.347,3.646,2.052c17.391,10.173,36.323,16.762,56.271,19.585c0.063,0.009,0.125,0.017,0.188,0.024
                                            l81.881,9.427c0.453,0.065,0.903,0.14,1.35,0.224c12.054,2.264,21.568,11.171,24.751,22.77c0.472,1.718,0.804,3.496,0.986,5.319
                                            l0.325,3.27l-153.46-13.445c-4.018-0.351-7.566,2.622-7.918,6.642c-0.353,4.021,2.622,7.566,6.642,7.918l162.242,14.215
                                            c0.039,0.003,0.077,0.002,0.115,0.005c0.038,0.003,0.075,0.009,0.114,0.012l30.597,1.717c0.137,0.008,0.273,0.011,0.409,0.011
                                            c0.145,0,0.288-0.023,0.432-0.032c0.163-0.01,0.326-0.016,0.488-0.036c0.218-0.028,0.431-0.075,0.645-0.122
                                            c0.153-0.034,0.307-0.059,0.457-0.103c0.234-0.067,0.459-0.158,0.686-0.249c0.122-0.049,0.248-0.086,0.368-0.142
                                            c0.341-0.158,0.673-0.34,0.989-0.552l25.972-17.381c0.001-0.001,0.002-0.002,0.003-0.003l76.702-51.332
                                            c7.717-5.187,18.251-3.152,23.482,4.536C499.249,333.181,498.062,342.736,491.673,348.41z"
                        />
                      </g>
                    </g>
                  </svg>
                </div>
                <div class="info-body">
                  <h3 class="info__title">
                    <a href="/jacket">Jacket Back Digitizing</a>{" "}
                  </h3>
                  <p class="info__text">
                    Dotemb is your dedicated partner for Jacket Back Digitizing,
                    delivering precision and detail to make your jackets stand
                    out. Elevate your brand, team, or personal style with our
                    specialized digitizing services tailored for jacket back
                    designs.
                  </p>
                </div>
              </div>
            </div>
            <div class="col-lg-4 col-sm-6">
              <div class="info-box-item info-box-item-4">
                <div class="info-header">
                  <svg
                    class="infobg__svg"
                    width="180"
                    height="180"
                    viewBox="0 0 600 600"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <g transform="translate(300,300)">
                      <path d="M125.6,-88.7C153,-25,158.8,35,134.2,52.8C109.7,70.7,54.8,46.3,9.7,40.8C-35.5,35.2,-71,48.3,-103.2,26.1C-135.4,3.8,-164.3,-53.8,-146.5,-111.9C-128.7,-170,-64.4,-228.5,-7.6,-224.1C49.1,-219.7,98.1,-152.3,125.6,-88.7Z" />
                    </g>
                  </svg>
                  <svg
                    class="info__svg"
                    viewBox="0 0 569 569.54905"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path d="m1.527344 52.246094 37.984375 66.46875c1.28125 2.246094 3.425781 3.871094 5.933593 4.5l35.4375 8.859375 121.542969 121.542969 13.429688-13.425782-123.445313-123.441406c-1.214844-1.21875-2.738281-2.082031-4.40625-2.5l-34.050781-8.542969-32.339844-56.625 27.726563-27.726562 56.648437 32.371093 8.546875 34.050782c.414063 1.671875 1.28125 3.199218 2.496094 4.414062l123.445312 123.445313 13.425782-13.429688-121.542969-121.542969-8.859375-35.417968c-.628906-2.511719-2.253906-4.660156-4.5-5.945313l-66.472656-37.980469c-3.707032-2.109374-8.371094-1.484374-11.394532 1.527344l-37.980468 37.984375c-3.0546878 3.003907-3.71875 7.675781-1.625 11.414063zm0 0" />
                    <path d="m396.3125 187.144531-208.902344 208.90625-13.429687-13.429687 208.90625-208.902344zm0 0" />
                    <path d="m150.847656 403.441406c-1.71875-2.859375-4.804687-4.605468-8.140625-4.605468h-56.972656c-3.332031 0-6.421875 1.746093-8.136719 4.605468l-28.488281 47.476563c-1.808594 3.007812-1.808594 6.769531 0 9.78125l28.488281 47.476562c1.714844 2.855469 4.804688 4.605469 8.136719 4.605469h56.972656c3.335938 0 6.421875-1.75 8.140625-4.605469l28.484375-47.476562c1.808594-3.011719 1.808594-6.773438 0-9.78125zm-13.511718 90.347656h-46.226563l-22.789063-37.980468 22.789063-37.984375h46.226563l22.789062 37.984375zm0 0" />
                    <path d="m456.0625 227.914062c62.714844.210938 113.730469-50.460937 113.941406-113.175781.03125-9.546875-1.140625-19.054687-3.488281-28.308593-1.265625-5.089844-6.417969-8.1875-11.507813-6.921876-1.671874.417969-3.195312 1.28125-4.414062 2.496094l-59.109375 59.070313-46.898437-15.628907-15.640626-46.886718 59.109376-59.121094c3.707031-3.710938 3.703124-9.722656-.007813-13.429688-1.222656-1.222656-2.761719-2.089843-4.445313-2.503906-60.820312-15.402344-122.605468 21.414063-138.007812 82.230469-2.339844 9.226563-3.507812 18.710937-3.476562 28.230469.023437 7.476562.792968 14.929687 2.308593 22.25l-207.957031 207.953125c-7.320312-1.511719-14.773438-2.28125-22.246094-2.308594-62.933594 0-113.949218 51.015625-113.949218 113.949219 0 62.929687 51.015624 113.945312 113.949218 113.945312 62.929688 0 113.945313-51.015625 113.945313-113.945312-.023438-7.476563-.796875-14.929688-2.308594-22.25l49.785156-49.785156 21.773438 21.773437c3.710937 3.707031 9.71875 3.707031 13.429687 0l4.746094-4.75c4.164062-4.136719 10.894531-4.136719 15.058594 0 4.160156 4.148437 4.167968 10.882813.019531 15.042969-.003906.003906-.011719.011718-.019531.019531l-4.746094 4.746094c-3.707031 3.707031-3.707031 9.71875 0 13.425781l113.273438 113.273438c29.792968 30.066406 78.316406 30.285156 108.382812.492187 30.0625-29.792969 30.28125-78.320313.488281-108.382813-.160156-.164062-.324219-.328124-.488281-.492187l-113.273438-113.269531c-3.707031-3.707032-9.71875-3.707032-13.425781 0l-4.746093 4.746094c-4.167969 4.140624-10.894532 4.140624-15.0625 0-4.15625-4.148438-4.167969-10.882813-.019532-15.039063.007813-.007813.015625-.011719.019532-.019531l4.75-4.75c3.707031-3.707032 3.707031-9.71875 0-13.425782l-21.773438-21.773437 49.785156-49.785156c7.320313 1.511719 14.773438 2.285156 22.246094 2.308593zm37.308594 322.851563c-6.898438-.011719-13.738282-1.257813-20.195313-3.683594l74.160157-74.164062c11.191406 29.769531-3.867188 62.972656-33.636719 74.164062-6.496094 2.441407-13.382813 3.691407-20.328125 3.683594zm-107.574219-246.792969c-10.515625 12.542969-8.867187 31.238282 3.675781 41.75 11.023438 9.238282 27.089844 9.230469 38.101563-.027344l106.5625 106.65625c1.15625 1.160157 2.238281 2.382813 3.285156 3.625l-81.1875 81.1875c-1.246094-1.042968-2.46875-2.125-3.628906-3.285156l-106.644531-106.652344c10.515624-12.542968 8.867187-31.238281-3.675782-41.75-11.023437-9.242187-27.09375-9.230468-38.105468.023438l-15.191407-15.191406 81.613281-81.492188zm38.34375-95.503906-215.410156 215.367188c-2.363281 2.359374-3.3125 5.785156-2.507813 9.023437 13.027344 51.160156-17.886718 103.195313-69.050781 116.21875-51.160156 13.027344-103.195313-17.886719-116.222656-69.050781-13.023438-51.160156 17.890625-103.195313 69.054687-116.222656 15.476563-3.9375 31.691406-3.9375 47.167969 0 3.238281.792968 6.65625-.15625 9.023437-2.503907l215.359376-215.371093c2.359374-2.359376 3.308593-5.785157 2.496093-9.019532-12.9375-50.5625 17.5625-102.039062 68.125-114.980468 9.554688-2.441407 19.4375-3.378907 29.28125-2.765626l-50.089843 50.109376c-2.542969 2.539062-3.433594 6.300781-2.296876 9.710937l18.988282 56.976563c.949218 2.832031 3.175781 5.058593 6.011718 6l56.976563 18.992187c3.40625 1.136719 7.167969.25 9.710937-2.289063l50.089844-50.089843c.113282 1.8125.171875 3.605469.171875 5.390625.265625 52.175781-41.8125 94.6875-93.988281 94.957031-8.066406.039063-16.105469-.953125-23.917969-2.953125-3.238281-.808594-6.664062.136719-9.023437 2.496094h.050781zm0 0" />
                    <path d="m491.273438 477.578125-13.429688 13.429687-94.953125-94.953124 13.425781-13.429688zm0 0" />
                  </svg>
                </div>
                <div class="info-body">
                  <h3 class="info__title">
                    <a href="/logo">Logo Digitizing</a>
                  </h3>
                  <p class="info__text">
                    Dotemb specializes in Logo Digitizing services, ensuring
                    that your brand logos are translated into impeccable,
                    high-quality embroidery designs. Elevate your brand presence
                    with our expert digitization tailored for logos of all sizes
                    and complexities.
                  </p>
                </div>
              </div>
            </div>
            <div class="col-lg-4 col-sm-6">
              <div class="info-box-item info-box-item-4">
                <div class="info-header">
                  <svg
                    class="infobg__svg"
                    width="180"
                    height="180"
                    viewBox="0 0 600 600"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <g transform="translate(300,300)">
                      <path d="M125.6,-88.7C153,-25,158.8,35,134.2,52.8C109.7,70.7,54.8,46.3,9.7,40.8C-35.5,35.2,-71,48.3,-103.2,26.1C-135.4,3.8,-164.3,-53.8,-146.5,-111.9C-128.7,-170,-64.4,-228.5,-7.6,-224.1C49.1,-219.7,98.1,-152.3,125.6,-88.7Z" />
                    </g>
                  </svg>
                  <svg
                    class="info__svg"
                    viewBox="0 0 64 64"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path d="m61.234 18.322a3 3 0 0 0 -4.243 0l-6.364 6.365a1 1 0 1 1 -1.414-1.415l.694-.694.013-.013 1.414-1.414a3 3 0 1 0 -4.242-4.243l-2.828 2.828a1 1 0 1 1 -1.415-1.414l2.829-2.828a3 3 0 1 0 -4.243-4.243l-2.829 2.829a1.022 1.022 0 0 1 -1.414 0 1 1 0 0 1 0-1.413l5.071-5.067a3 3 0 0 0 0-4.243 3.071 3.071 0 0 0 -4.243 0l-8.745 8.743a3.073 3.073 0 0 0 -3.4.569l-5.658 5.656a3 3 0 0 0 0 4.243l19.8 19.8a3 3 0 0 0 4.242 0l.707-.707 1.415 1.414-4.243 4.243-12.723-12.732a3.071 3.071 0 0 0 -4.243 0l-7.909 7.908a2.993 2.993 0 0 0 -3.405.577l-10.607 10.607a3 3 0 0 0 0 4.242l2.829 2.829a3 3 0 0 0 4.242 0l10.607-10.607a3 3 0 0 0 .577-3.405l5.787-5.787 12.728 12.728a3 3 0 0 0 4.242 0l8.486-8.486a3 3 0 0 0 0-4.242l-3.536-3.536.708-.707a3 3 0 0 0 .579-3.407l10.734-10.735a3 3 0 0 0 0-4.243zm-18.385 22.628a1.022 1.022 0 0 1 -1.413 0l-19.8-19.8a1 1 0 0 1 0-1.415l5.657-5.656a1 1 0 0 1 1.414 0l19.8 19.8a1 1 0 0 1 0 1.415zm-23.334 7.778-10.607 10.606a1 1 0 0 1 -1.414 0l-2.828-2.828a1 1 0 0 1 0-1.414l10.606-10.607a1 1 0 0 1 1.415 0l2.828 2.828a1 1 0 0 1 0 1.415zm31.819-6.364a1 1 0 0 1 0 1.414l-8.485 8.486a1.025 1.025 0 0 1 -1.414 0l-12.728-12.728a2 2 0 0 0 -2.828 0l-5.657 5.656-1.414-1.414 7.778-7.778a1.023 1.023 0 0 1 1.414 0l12.729 12.729a2 2 0 0 0 2.827 0l4.244-4.244a2 2 0 0 0 0-2.828l-1.414-1.414 1.414-1.415zm8.486-21.213-10.607 10.606-18.385-18.385 8.608-8.606a1.021 1.021 0 0 1 1.413 0 1 1 0 0 1 0 1.413l-5.071 5.071a3 3 0 0 0 0 4.243 3.073 3.073 0 0 0 4.243 0l2.828-2.828a1 1 0 0 1 1.415 1.414l-2.829 2.828a3 3 0 0 0 4.243 4.243l2.828-2.829a1.023 1.023 0 0 1 1.414 0 1 1 0 0 1 0 1.415l-2.12 2.122a3 3 0 0 0 4.242 4.242l6.363-6.364a1 1 0 1 1 1.415 1.414z" />
                    <path d="m49.213 10.714a3 3 0 1 1 2.121-.877 2.988 2.988 0 0 1 -2.121.877zm0-4a1 1 0 1 0 .707 1.707 1 1 0 0 0 -.707-1.706z" />
                    <path d="m54.87 16.373a3 3 0 0 1 -2.121-5.122 3.073 3.073 0 0 1 4.243 0 3 3 0 0 1 0 4.243 2.978 2.978 0 0 1 -2.122.879zm0-4a1 1 0 0 0 -.707 1.706 1.022 1.022 0 0 0 1.414 0 1 1 0 0 0 -.707-1.706z" />
                  </svg>
                </div>
                <div class="info-body">
                  <h3 class="info__title">
                    <a href="/cap">Cap Digitizing Service</a>
                  </h3>
                  <p class="info__text">
                    Dotemb specializes in Cap Digitizing services, ensuring that
                    your cap designs are transformed into impeccable,
                    high-quality embroidered masterpieces. From logos to
                    intricate artwork, our expertise is tailored to bring your
                    cap designs to life with precision and style.
                  </p>
                </div>
              </div>
            </div>
            <div class="col-lg-4 col-sm-6">
              <div class="info-box-item info-box-item-4">
                <div class="info-header">
                  <svg
                    class="infobg__svg"
                    width="180"
                    height="180"
                    viewBox="0 0 600 600"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <g transform="translate(300,300)">
                      <path d="M125.6,-88.7C153,-25,158.8,35,134.2,52.8C109.7,70.7,54.8,46.3,9.7,40.8C-35.5,35.2,-71,48.3,-103.2,26.1C-135.4,3.8,-164.3,-53.8,-146.5,-111.9C-128.7,-170,-64.4,-228.5,-7.6,-224.1C49.1,-219.7,98.1,-152.3,125.6,-88.7Z" />
                    </g>
                  </svg>
                  <svg
                    class="info__svg"
                    version="1.1"
                    id="Capa_2"
                    xmlns="http://www.w3.org/2000/svg"
                    x="0px"
                    y="0px"
                    viewBox="0 0 60 60"
                  >
                    <path
                      d="M58.681,46h0.042l-0.238-1.177L52.347,8H17.5V6c0-2.206,1.794-4,4-4s4,1.794,4,4c0,0.553,0.448,1,1,1s1-0.447,1-1
                                c0-3.309-2.691-6-6-6s-6,2.691-6,6v2H7.653L1.516,44.823L1.278,46h0.042H25.5v9h-3v5h15v-5h-3v-9H58.681z M9.347,10H15.5v7
                                c0,0.553,0.448,1,1,1s1-0.447,1-1v-7h33.153l4.5,27H4.847L9.347,10z M3.722,44l1.01-5h50.536l1.01,5H34.5h-9H3.722z M35.5,57v1h-11
                                v-1h1h9H35.5z M32.5,55h-5v-9h5V55z"
                    />
                  </svg>
                </div>
                <div class="info-body">
                  <h3 class="info__title">
                    <a href="/embroiderypatch">Embroidery Patches</a>
                  </h3>
                  <p class="info__text">
                    "Patches: PVC, Silicone, Leather and Rubber. Woven LABELs
                    and Tags Custom order, Any shape with Artwork team to help
                    you. Heat Press and Velcro options are available. RUSH
                    service with high quality is acceptable."
                  </p>
                </div>
              </div>
            </div>
            <div class="col-lg-4 col-sm-6">
              <div class="info-box-item info-box-item-4">
                <div class="info-header">
                  <svg
                    class="infobg__svg"
                    width="180"
                    height="180"
                    viewBox="0 0 600 600"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <g transform="translate(300,300)">
                      <path d="M125.6,-88.7C153,-25,158.8,35,134.2,52.8C109.7,70.7,54.8,46.3,9.7,40.8C-35.5,35.2,-71,48.3,-103.2,26.1C-135.4,3.8,-164.3,-53.8,-146.5,-111.9C-128.7,-170,-64.4,-228.5,-7.6,-224.1C49.1,-219.7,98.1,-152.3,125.6,-88.7Z" />
                    </g>
                  </svg>
                  <svg
                    class="info__svg"
                    version="1.1"
                    id="Capa_3"
                    xmlns="http://www.w3.org/2000/svg"
                    x="0px"
                    y="0px"
                    viewBox="0 0 512 512"
                  >
                    <g>
                      <g>
                        <path
                          d="M506.552,317.933c-9.739-14.312-29.351-18.1-43.707-8.452l-65.34,43.728l-0.19-136.11l22.7,21.265
                                            c4.827,4.521,11.121,7.009,17.729,7.009c0.012,0,0.026,0,0.039,0c7.134-0.01,14.022-3,18.898-8.205
                                            c4.737-5.057,7.222-11.655,6.996-18.581c-0.226-6.926-3.136-13.349-8.193-18.086l-43.035-40.314
                                            c-2.946-2.76-7.571-2.609-10.33,0.337c-2.759,2.946-2.608,7.57,0.337,10.33l43.035,40.314c2.208,2.068,3.478,4.872,3.577,7.895
                                            c0.098,3.023-0.986,5.904-3.055,8.111c-2.16,2.306-5.09,3.578-8.252,3.582c-0.006,0-0.011,0-0.017,0
                                            c-2.883,0-5.63-1.086-7.737-3.06c-0.001-0.001-0.001-0.001-0.001-0.001L259.124,67.616c-2.816-2.637-7.198-2.633-10.007,0.014
                                            L78.679,228.188c-2.201,2.074-5.079,3.16-8.103,3.076c-3.024-0.09-5.831-1.353-7.905-3.556c-2.074-2.201-3.167-5.079-3.076-8.102
                                            c0.09-3.024,1.353-5.831,3.554-7.905L246.326,39.143c4.342-4.091,11.154-4.101,15.507-0.021L369,139.514
                                            c2.945,2.759,7.57,2.609,10.33-0.337c2.759-2.946,2.608-7.57-0.337-10.33L271.827,28.455c-9.973-9.344-25.576-9.323-35.523,0.049
                                            l-58.639,55.24l-0.016-9.853c-0.004-3.106-1.218-6.024-3.417-8.216c-2.195-2.189-5.109-3.394-8.209-3.394
                                            c-0.006,0-0.011,0-0.017,0l-41.947,0.059c-3.106,0.004-6.023,1.218-8.216,3.417c-2.192,2.199-3.398,5.12-3.393,8.227l0.116,71.087
                                            l-59.439,55.993c-5.044,4.751-7.935,11.182-8.142,18.108c-0.207,6.926,2.296,13.518,7.047,18.56
                                            c4.75,5.044,11.181,7.936,18.108,8.143c0.265,0.008,0.53,0.012,0.795,0.012c6.635,0,12.918-2.49,17.767-7.06l22.649-21.336
                                            l0.09,64.291c-7.328-1.067-14.742-1.627-22.19-1.627H76.746v-4.382c0-14.711-11.969-26.68-26.68-26.68H26.68
                                            C11.969,249.092,0,261.06,0,275.772V390.29c0,4.036,3.272,7.308,7.308,7.308s7.308-3.272,7.308-7.308V275.772
                                            c0-6.652,5.412-12.064,12.064-12.064h23.385c6.652,0,12.064,5.412,12.064,12.064v11.69v149.796v11.575
                                            c0,6.652-5.412,12.064-12.064,12.064H26.68c-6.652,0-12.064-5.412-12.064-12.064v-12.788c0-4.036-3.272-7.308-7.308-7.308
                                            S0,432.009,0,436.045v12.788c0,14.711,11.969,26.68,26.68,26.68h23.385c14.711,0,26.68-11.968,26.68-26.68v-0.993l107.024,40.528
                                            c0.198,0.075,0.399,0.141,0.603,0.198c4.653,1.314,9.304,1.973,13.896,1.973c2.484,0,4.951-0.193,7.393-0.579l157.281-22.672
                                            c0.037-0.005,0.073-0.011,0.11-0.017c13.372-2.135,25.987-7.788,36.48-16.346c0.091-0.074,0.181-0.151,0.268-0.23l101.611-91.388
                                            C513.244,348.802,515.453,331.015,506.552,317.933z M163.037,76.902l0.034,20.59l-35.912,33.83l-0.089-54.371L163.037,76.902z
                                             M254.141,82.976l128.538,120.412l0.223,159.593l-20.691,13.848L340.3,375.6l-0.579-5.82
                                            c-2.039-20.498-17.171-36.987-37.18-40.922l-0.132-94.945c-0.01-7.286-5.942-13.207-13.227-13.207c-0.006,0-0.011,0-0.018,0
                                            l-69.654,0.098c-3.533,0.005-6.853,1.385-9.347,3.887c-2.495,2.501-3.866,5.825-3.861,9.357l0.116,82.781
                                            c-13.797-3.154-26.971-8.363-39.288-15.568c-1.537-0.899-3.089-1.767-4.654-2.611c-0.61-0.329-1.23-0.638-1.845-0.959
                                            c-0.952-0.497-1.902-0.997-2.864-1.474c-0.766-0.38-1.541-0.74-2.313-1.107c-0.819-0.389-1.637-0.782-2.462-1.157
                                            c-0.84-0.381-1.687-0.744-2.533-1.11c-0.773-0.334-1.546-0.67-2.324-0.991c-0.87-0.359-1.745-0.704-2.621-1.047
                                            c-0.777-0.304-1.555-0.606-2.336-0.898c-0.867-0.324-1.738-0.637-2.611-0.944c-0.819-0.289-1.639-0.571-2.463-0.846
                                            c-0.836-0.279-1.674-0.552-2.516-0.817c-0.897-0.283-1.798-0.553-2.7-0.82c-0.775-0.228-1.549-0.456-2.328-0.672
                                            c-1.017-0.283-2.039-0.548-3.062-0.81c-0.479-0.123-0.955-0.262-1.437-0.381l-0.113-80.878L254.141,82.976z M287.923,327.029
                                            l-61.125-7.037l-5.759-0.663l-0.118-83.911l66.874-0.094L287.923,327.029z M491.673,348.41l-101.511,91.298
                                            c-8.459,6.859-18.606,11.396-29.361,13.122l-157.213,22.662c-0.033,0.005-0.065,0.01-0.098,0.015l-0.109,0.017
                                            c-4.763,0.754-9.723,0.436-14.744-0.942L76.746,432.21V294.77h12.505c10.645,0,21.218,1.229,31.514,3.616
                                            c0.383,0.089,0.765,0.18,1.147,0.272c1.265,0.305,2.527,0.619,3.783,0.959c0.11,0.03,0.219,0.062,0.329,0.092
                                            c1.259,0.344,2.513,0.707,3.763,1.086c0.224,0.068,0.449,0.135,0.672,0.204c1.33,0.411,2.654,0.84,3.971,1.29
                                            c0.136,0.047,0.271,0.095,0.407,0.142c2.743,0.947,5.459,1.98,8.141,3.098c0.146,0.061,0.292,0.122,0.438,0.184
                                            c1.337,0.562,2.666,1.143,3.986,1.747c0.035,0.016,0.071,0.033,0.106,0.05c1.276,0.586,2.543,1.194,3.802,1.819
                                            c0.148,0.073,0.297,0.145,0.445,0.219c1.23,0.615,2.45,1.252,3.663,1.904c0.229,0.123,0.457,0.249,0.686,0.373
                                            c1.224,0.667,2.441,1.347,3.646,2.052c17.391,10.173,36.323,16.762,56.271,19.585c0.063,0.009,0.125,0.017,0.188,0.024
                                            l81.881,9.427c0.453,0.065,0.903,0.14,1.35,0.224c12.054,2.264,21.568,11.171,24.751,22.77c0.472,1.718,0.804,3.496,0.986,5.319
                                            l0.325,3.27l-153.46-13.445c-4.018-0.351-7.566,2.622-7.918,6.642c-0.353,4.021,2.622,7.566,6.642,7.918l162.242,14.215
                                            c0.039,0.003,0.077,0.002,0.115,0.005c0.038,0.003,0.075,0.009,0.114,0.012l30.597,1.717c0.137,0.008,0.273,0.011,0.409,0.011
                                            c0.145,0,0.288-0.023,0.432-0.032c0.163-0.01,0.326-0.016,0.488-0.036c0.218-0.028,0.431-0.075,0.645-0.122
                                            c0.153-0.034,0.307-0.059,0.457-0.103c0.234-0.067,0.459-0.158,0.686-0.249c0.122-0.049,0.248-0.086,0.368-0.142
                                            c0.341-0.158,0.673-0.34,0.989-0.552l25.972-17.381c0.001-0.001,0.002-0.002,0.003-0.003l76.702-51.332
                                            c7.717-5.187,18.251-3.152,23.482,4.536C499.249,333.181,498.062,342.736,491.673,348.41z"
                        />
                      </g>
                    </g>
                  </svg>
                </div>
                <div class="info-body">
                  <h3 class="info__title">
                    <a href="/sleeve">Sleeve Digitizing</a>
                  </h3>
                  <p class="info__text">
                    Dotemb specializes in Sleeve Digitizing services, offering
                    precision and creativity for your sleeve designs. From logos
                    to intricate artwork, our expertise is tailored to enhance
                    the visual impact of your garments with meticulously
                    digitized sleeves.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <div class="section-block"></div>
      {/* <section class="testimonial-area2 client-feedback2 section--padding text-center">
    <div class="container">
        <div class="row">
            <div class="col-lg-8 mx-auto">
                <div class="section-heading">
                    <h5 class="section__meta">#testimonial</h5>
                    <h2 class="section__title">Check What Our Lovely Client Said About us!</h2>
                    <div class="section-divider mx-auto"></div>
                </div>
                <div class="section-description">
                    <p class="section__desc">
                        Lorem ipsum dolor sit amet, consectetur adipisicing elit. Deleniti facilis
                        inventore optio quis ratione totam voluptatibus. Consequatur
                    </p>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-lg-12">
                <div class="testimonial-item-wrap-8 testimonial-carousel-2">
                    <div class="testimonial-item">
                        <div class="testimonial__img">
                            <img src="images/testi-img1.jpg" alt="testimonial-image" />
                        </div>
                        <div class="testimonial-content">
                            <div class="testimonial-author">
                                <h3 class="author__title">Jack Hardson</h3>
                                <span class="author__meta">UI/UX Designer</span>
                                <span class="author__rating">
                                    <i class="la la-star"></i>
                                    <i class="la la-star"></i>
                                    <i class="la la-star"></i>
                                    <i class="la la-star"></i>
                                    <i class="la la-star"></i>
                                </span>
                            </div>
                            <div class="testimonial-desc">
                                <span class="la la-quote-left"></span>
                                <p class="testimonial__desc">
                                    Lorem ipsum dolor sit amet, consectetur adipisicing elit. Ab accusamus accusantium adipisci aliquam aperiam
                                </p>
                            </div>
                        </div>
                    </div>
                    <div class="testimonial-item">
                        <div class="testimonial-single-item">
                            <div class="testimonial__img">
                                <img src="images/testi-img2.jpg" alt="testimonial-image" />
                            </div>
                            <div class="testimonial-content">
                                <div class="testimonial-author">
                                    <h3 class="author__title">Kavin Martin</h3>
                                    <span class="author__meta">Manager</span>
                                    <span class="author__rating">
                                    <i class="la la-star"></i>
                                    <i class="la la-star"></i>
                                    <i class="la la-star"></i>
                                    <i class="la la-star"></i>
                                    <i class="la la-star"></i>
                                </span>
                                </div>
                                <div class="testimonial-desc">
                                    <span class="la la-quote-left"></span>
                                    <p class="testimonial__desc">
                                        Lorem ipsum dolor sit amet, consectetur adipisicing elit. Ab accusamus accusantium adipisci aliquam aperiam
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="testimonial-item">
                        <div class="testimonial-single-item">
                            <div class="testimonial__img">
                                <img src="images/testi-img3.jpg" alt="testimonial-image" />
                            </div>
                            <div class="testimonial-content">
                                <div class="testimonial-author">
                                    <h3 class="author__title">Kamran Ahmed</h3>
                                    <span class="author__meta">Web Developer</span>
                                    <span class="author__rating">
                                    <i class="la la-star"></i>
                                    <i class="la la-star"></i>
                                    <i class="la la-star"></i>
                                    <i class="la la-star"></i>
                                    <i class="la la-star"></i>
                                </span>
                                </div>
                                <div class="testimonial-desc">
                                    <span class="la la-quote-left"></span>
                                    <p class="testimonial__desc">
                                        Lorem ipsum dolor sit amet, consectetur adipisicing elit. Ab accusamus accusantium adipisci aliquam aperiam
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section> */}
      {/* <section class="team-area bg-gray section--padding ">
        <div class="container">
          <div class="row">
            <div class="col-lg-12">
              <div class="section-heading text-center">
                <h5 class="section__meta">#expert people</h5>
                <h2 class="section__title">Meet Our Team</h2>
                <div class="section-divider mx-auto"></div>
              </div>
            </div>
          </div>
          <div class="row team-content-wrap">
            <div class="col-lg-3 col-sm-6">
              <div class="team-item team-item-7">
                <div class="team-img-box">
                  <img src="images/team.jpg" alt="" />
                  <ul class="team__profile">
                    <li>
                      <a href="#">
                        <i class="lab la-twitter"></i>
                      </a>
                    </li>
                    <li>
                      <a href="#">
                        <i class="lab la-facebook-f"></i>
                      </a>
                    </li>
                    <li>
                      <a href="#">
                        <i class="lab la-linkedin-in"></i>
                      </a>
                    </li>
                    <li>
                      <a href="#">
                        <i class="lab la-instagram"></i>
                      </a>
                    </li>
                  </ul>
                </div>
                <div class="team-titles">
                  <h3 class="team__title">
                    <a href="team-single.html">alex smith</a>
                  </h3>
                  <p class="team__meta">Director</p>
                </div>
              </div>
            </div>
            <div class="col-lg-3 col-sm-6">
              <div class="team-item team-item-7">
                <div class="team-img-box">
                  <img src="images/team2.jpg" alt="" />
                  <ul class="team__profile">
                    <li>
                      <a href="#">
                        <i class="lab la-twitter"></i>
                      </a>
                    </li>
                    <li>
                      <a href="#">
                        <i class="lab la-facebook-f"></i>
                      </a>
                    </li>
                    <li>
                      <a href="#">
                        <i class="lab la-linkedin-in"></i>
                      </a>
                    </li>
                    <li>
                      <a href="#">
                        <i class="lab la-instagram"></i>
                      </a>
                    </li>
                  </ul>
                </div>
                <div class="team-titles">
                  <h3 class="team__title">
                    <a href="team-single.html">Tom Carry</a>
                  </h3>
                  <p class="team__meta">Manager</p>
                </div>
              </div>
            </div>
            <div class="col-lg-3 col-sm-6">
              <div class="team-item team-item-7">
                <div class="team-img-box">
                  <img src="images/team3.jpg" alt="" />
                  <ul class="team__profile">
                    <li>
                      <a href="#">
                        <i class="lab la-twitter"></i>
                      </a>
                    </li>
                    <li>
                      <a href="#">
                        <i class="lab la-facebook-f"></i>
                      </a>
                    </li>
                    <li>
                      <a href="#">
                        <i class="lab la-linkedin-in"></i>
                      </a>
                    </li>
                    <li>
                      <a href="#">
                        <i class="lab la-instagram"></i>
                      </a>
                    </li>
                  </ul>
                </div>
                <div class="team-titles">
                  <h3 class="team__title">
                    <a href="team-single.html">Collin Smith</a>
                  </h3>
                  <p class="team__meta">Sales</p>
                </div>
              </div>
            </div>
            <div class="col-lg-3 col-sm-6">
              <div class="team-item team-item-7">
                <div class="team-img-box">
                  <img src="images/team4.jpg" alt="" />
                  <ul class="team__profile">
                    <li>
                      <a href="#">
                        <i class="lab la-twitter"></i>
                      </a>
                    </li>
                    <li>
                      <a href="#">
                        <i class="lab la-facebook-f"></i>
                      </a>
                    </li>
                    <li>
                      <a href="#">
                        <i class="lab la-linkedin-in"></i>
                      </a>
                    </li>
                    <li>
                      <a href="#">
                        <i class="lab la-instagram"></i>
                      </a>
                    </li>
                  </ul>
                </div>
                <div class="team-titles">
                  <h3 class="team__title">
                    <a href="team-single.html">Josh Clark</a>
                  </h3>
                  <p class="team__meta">Support</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section> */}
      <section class="form-area ">
        <div class="container ">
          <div class="row ">
            <div class="col-lg-12 pt-5">
              <div class="section-heading text-center">
                <h5 class="section__meta">pricing plan</h5>
                <h2 class="section__title">
                  Pick Package That Suits Your Needs
                </h2>
              </div>
            </div>
          </div>
          <div
            class="row"
            style={{
              display: "flex",
              justifyContent: "center",
              marginTop: "30px",
            }}
          >
            <div class="col-lg-4">
              <div class="package-item package-item-2 package-item-active-2">
                {/* <div class="package-tooltip">
                  <span class="package__tooltip">Popular</span>
                </div> */}
                <div class="package-title">
                  <h3 class="package__title"> Digitizing Prices</h3>
                </div>
                <div class="package-price">
                  <p
                    style={{
                      color: "black",
                      fontSize: "15px",
                      fontWeight: "600",
                    }}
                  >
                    Left Chest Logos ro Hat Logos
                  </p>
                  <p class="package__meta">Up to 5000 Stitches - £ 5 </p>
                  <p class="package__meta">5001 to 20000 Stitches -£10 </p>
                  <p class="package__meta">Above 20000 Stitches -£15</p>
                </div>{" "}
              </div>
            </div>{" "}
            <div class="col-lg-4">
              <div class="package-item package-item-2 package-item-active-2">
                {/* <div class="package-tooltip">
                  <span class="package__tooltip">Popular</span>
                </div> */}
                <div class="package-title">
                  <h3 class="package__title"> Digitizing Prices</h3>
                </div>

                <div class="package-price ">
                  <p
                    style={{
                      color: "black",
                      fontSize: "15px",
                      fontWeight: "600",
                    }}
                  >
                    Full Back Logos
                  </p>
                  <p class="package__meta">Up to 50000 Stitches -£20</p>
                  <p class="package__meta">Up to 100000 Stitches -£30</p>
                  <p class="package__meta">Up to 200000 Stitches -£40</p>
                </div>
              </div>
            </div>
            <div class="col-lg-4">
              <div class="package-item package-item-2">
                <div class="package-title">
                  <h3
                    class="package__title"
                    style={{ textTransform: "capitalize" }}
                  >
                    {" "}
                    Vectoring Prices
                  </h3>
                </div>
                <div class="package-price" style={{ marginTop: "-30px" }}>
                  <p class="package__meta">Simple Up to -£5</p>
                  <p class="package__meta">Medium Up to -£10</p>
                  <p class="package__meta">Complex Up to -£30</p>
                </div>{" "}
              </div>
            </div>{" "}
          </div>
          {/* <div
            class="row "
            style={{ display: "flex", justifyContent: "center" }}
          >
            <div class="button-shared text-right">
              <a href="/pricing" class="theme-btn">
                View More About Pricing<span class="la la-caret-right"></span>
              </a>
            </div>
          </div> */}
        </div>
      </section>{" "}
      <div class="section-block"></div>
      {/* <section class="funfact-area4 section--padding text-center">
    <div class="container">
        <div class="row">
            <div class="col-lg-12">
                <div class="section-heading pb-3">
                    <div class="section-icon mx-auto"></div>
                    <h5 class="section__meta">funfacts</h5>
                    <h2 class="section__title">See What Numbers Speak</h2>
                </div>
            </div>
        </div>
        <div class="row counter-wrap mt-5">
            <div class="col-lg-3 col-sm-6">
                <div class="counter-item counter-item-4">
                    <div class="counter-content">
                        <span class="counter__icon mx-auto la la-check-circle-o"></span>
                       <span class="counter counter__numb">30</span>                        <h3 class="counter__title">Years of experience</h3>
                    </div>
                </div>
            </div>
            <div class="col-lg-3 col-sm-6">
                <div class="counter-item counter-item-4">
                    <div class="counter-content">
                        <span class="counter__icon mx-auto la la-users"></span>
                        <span class="counter counter__numb">90,985</span>
                        <h3 class="counter__title">Worldwide Customers</h3>
                    </div>
                </div>
            </div>
            <div class="col-lg-3 col-sm-6">
                <div class="counter-item counter-item-4">
                    <div class="counter-content">
                        <span class="counter__icon mx-auto la la-lock"></span>
                        <span class="counter counter__numb">77785</span>
                        <h3 class="counter__title">Websites Protected</h3>
                    </div>
                </div>
            </div>
            <div class="col-lg-3 col-sm-6">
                <div class="counter-item counter-item-4">
                    <div class="counter-content">
                        <span class="counter__icon mx-auto la la-globe"></span>
                        <span class="counter counter__numb">4500</span>
                        <h3 class="counter__title">Domains Registered</h3>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section> */}
      <section class="about-area about-area3 section--padding">
        <div class="container">
          <div class="row">
            <div class="col-lg-6">
              <div class="about-item">
                <div class="about-heading section-heading about-right">
                  <div class="section-dot"></div>
                  <h5 class="section__meta rounded-radius">about us</h5>
                  <h2 class="section__title">FEATURES OF Dotemb</h2>
                </div>
                <div class="section-description">
                  <p class="section__desc">
                    Ensuring that digitized files are compatible with a wide
                    range of embroidery machines.
                  </p>
                </div>
                <ul class="list-items">
                  <li>
                    <span class="la la-check"></span> Offering high-quality
                    custom digitizing services to bring your designs to life in
                    embroidery.
                  </li>
                  <li>
                    <span class="la la-check"></span>Accepting a wide range of
                    file formats to accommodate various design needs.
                  </li>
                  <li>
                    <span class="la la-check"></span> Ensuring quick and
                    efficient delivery of digitized files, meeting tight
                    deadlines.
                  </li>{" "}
                  <li>
                    <span class="la la-check"></span>Streamlined online
                    platforms for easy order submission and secure payment
                    processing.
                  </li>
                  <li>
                    <span class="la la-check"></span>Skilled professionals
                    available to make adjustments and modifications to designs
                    as per client specifications.0000
                  </li>
                </ul>
                {/* <a href="/about" class="theme-btn">know more <span class="la la-caret-right"></span></a> */}
              </div>
            </div>
            <div class="col-lg-6">
              <div class="image-box-wrap">
                <span class="company-logo">Dotemb</span>
                <div class="image-box">
                  <img
                    src="assets/images/emb4.png"
                    alt="about-img"
                    class="img__item"
                  />
                  <img
                    src="assets/images/hat.png"
                    alt="about-img"
                    class="img__item"
                  />
                  <img
                    src="assets/images/emb51.png"
                    alt="about-img"
                    class="img__item"
                  />
                  <img
                    src="assets/images/machine21.png"
                    alt="about-img"
                    class="img__item"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section class="get-start-area">
        <div class="container">
          <div class="row align-items-center">
            <div class="col-lg-12">
              <div class="get-start-box">
                <div class="col-lg-8">
                  <div class="section-heading">
                    <h5 class="section__meta">#get in touch</h5>
                    <h2 class="section__title">Do you have any projects?</h2>

                    <p class="section__sub">Feel free to reach out to us.</p>
                  </div>
                </div>
                <div class="col-lg-4">
                  <div class="button-shared text-right">
                    <a href="/contact" class="theme-btn">
                      contact us <span class="la la-caret-right"></span>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
export default Home;
